import React from 'react';
import { ITutorProfileListItem } from 'types';
import css from './TutorCard.module.scss';
import { Link } from 'react-router-dom';
import { Icon, Rate, Tag } from 'antd';
import { priceForExperience } from 'utils';
import blankUser from 'static/img/blank_profile.png';
import { getItem } from 'utils/storage';
import { useTranslation } from 'react-i18next';
import { currency } from 'utils/env';

export default function TutorCard({
  tutor,
  locationDescription
}: {
  tutor: ITutorProfileListItem;
  locationDescription: string;
}) {
  const subject_id = getItem('SUBJECT');
  const level_id = getItem('LEVEL');
  const tutorWebUrl = `/tutor/${subject_id}/${level_id}/${tutor.id}`;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getExperience = (length: number = 150) =>
    tutor.experience.length > length
      ? `${tutor.experience.slice(0, length)}...`
      : tutor.experience;

  const { t } = useTranslation()

  return (
    <div className={css.tutorCard}>
      <div className={css.imageSection}>
        <div className={css.tutorProfilePicture}>
          <img className={css.tutorImg} src={tutor.photo_card || blankUser} alt={tutor.name} />
        </div>
        <div className={css.desktopFeatureReview}>
          {tutor.num_reviews > 1 && (
            <div className={css.reviews}>
              <Rate
                className={css.rate}
                disabled
                value={tutor.rating ? (tutor.rating + 20) / 20 : 0}
              />{' '}
              <div className={css.reviewsText}>{`(${tutor.num_reviews})`}</div>
            </div>
          )}
          {tutor.num_reviews < 1 && (
            <div className={css.featuredTutor}>{t('Featured Tutor')}</div>
          )}
        </div>
      </div>
      <div className={css.tutorContent}>
        <Link to={tutorWebUrl} target="_blank">
          <div className={css.tutorTitleLink}>
            <h3>{tutor.name}.</h3>
            <div className={css.showOnDesktop}>
              <div className={css.verifiedTutor}>
                <Icon className={css.icon} type="safety-certificate" />
                <span>{t('Verified Tutor')}</span>
              </div>
            </div>
            <div className={css.mobilePrice}>
              <div className={css.price}>
                {currency}{priceForExperience(tutor.selected_subject.experience)}/hr
              </div>
              {tutor.num_reviews > 1 && (
                <div className={css.reviews}>
                  <Rate
                    className={css.rate}
                    disabled
                    value={tutor.rating ? (tutor.rating + 20) / 20 : 0}
                  />{' '}
                  <div className={css.reviewsText}>{`(${
                    tutor.num_reviews
                  })`}</div>
                </div>
              )}
              {tutor.num_reviews < 1 && (
                <div className={css.featuredTutor}>{t('Featured Tutor')}</div>
              )}
            </div>
          </div>
        </Link>
        <p className={css.tagLine}>
          {tutor.tagline
            ? tutor.tagline
            : `${tutor.selected_subject.name} ${t('Tuition')} ${locationDescription}`}
        </p>

        <div className={css.showOnMobile}>
          <p className={css.experienceDescription}>{getExperience(90)}</p>
        </div>
        <div className={css.showOnDesktop}>
          <p className={css.experienceDescription}>{getExperience(150)}</p>
        </div>

        <div className={css.tags}>
          {tutor.response_time_display && (
            <Tag className={css.tag}>
              {t('Typically responds in in')} {tutor.response_time_display}
            </Tag>
          )}
        </div>
      </div>
      <div className={css.tutorStats}>
        <div className={css.showOnDesktop}>
          <div className={css.price}>
            {currency}{priceForExperience(tutor.selected_subject.experience)}/hour
          </div>
        </div>
        <div className={css.statList}>
          <div className={css.stat}>
            <Icon type="book" className={css.icon} />
            <span>{t('Degree Educated')}</span>
          </div>
          <div className={css.stat}>
            <Icon type="bar-chart" className={css.icon} />
            <span>{tutor.experience_years} {t('years experience')}</span>
          </div>
          <div className={css.stat}>
            <span className={css.lessons}>{tutor.experience_years*50}+</span>
            <span>{t('Lessons completed')}</span>
          </div>
          <div className={css.showOnMobile}>
            <div className={css.stat}>
              <Icon type="check-circle" className={css.icon} />
              <span>{t('Verified tutor')}</span>
            </div>
          </div>
        </div>
        <div className={css.showOnDesktop}>
          <div className={css.actions}>
            <Link to={tutorWebUrl} target="_blank" className={css.link}>
              <div className={css.viewProfileButton}>{t('View Profile')}</div>
            </Link>
          </div>
        </div>
      </div>
      <div className={css.viewProfileActionMobile}>
        <Link to={tutorWebUrl} target="_blank" className={css.link}>
          <div className={css.viewProfileButton}>{t('View Profile')}</div>
        </Link>
      </div>
    </div>
  );
}
